module.exports = __webpack_public_path__ + "img/GabinetePanelAbierto.50f903e8.svg";